// file start

import '../styles/theme.scss'

import {instagram} from './instagram.js'
import tippy from './tippy.js'

const $ = document.querySelector.bind(document)
const $$ = document.querySelectorAll.bind(document)

/** Configure **/
const tippyConfig = {
	arrow: true,
	arrowType: 'round',
	maxWidth: 300,
	offset: '0, 7',
	placement: 'bottom',
	size: 'large',
	theme: 'green'
}

/** Launch **/
void function () {
	addInstagram()
	addSearch()
	addTippy()
}()

/**
 *
 */
function addInstagram() {
	const $instagram = $('instagram')
	if (!$instagram) {
		return
	}

	let html = ``
	Object.values(instagram).forEach(entry => {
		html += `<instagram-photo style="background-image: url(${entry.thumbnail})" data-tippy-content="${entry.content.split('<img').shift()}"></instagram-photo>`
	})
	html += `<br style="clear: both;">`
	$instagram.innerHTML = html
}

/**
 *
 */
function addSearch() {
	const $search = $('.icon-search')
	if ($search) {
		$search.onclick = function () {
			$('header form').style.display = 'block'
			$('header nav').style.display = 'none'
			$('header input').focus()
		}
	}

	const $close = $('.icon-close')
	if ($close) {
		$close.onclick = function () {
			$('header form').style.display = 'none'
			$('header nav').style.display = 'block'
			document.activeElement.blur()
		}
	}
}

/**
 *
 */
function addTippy() {
	const $photos = $$('instagram-photo')
	if ($photos.length) {
		tippy.group(tippy($photos, Object.assign({}, tippyConfig, {
			placement: 'top'
		})))
	}

	const $products = $$('products .product')
	if ($products.length) {
		tippy.group(tippy($products, Object.assign({}, tippyConfig, {
			placement: 'top',
			offset: '0, 20'
		})))
	}

	const $content = $$('[data-tippy-content]')
	if ($content.length) {
		tippy.group(tippy($content, tippyConfig))
	}
}